export const EmptyList = () => {
  return (
    <div className="flex flex-col items-center justify-center py-4">
      <img src={require("@/images/fyndee.png")} alt="Fyndee" />
      <div className="text-center">Ooops! No results found.</div>
    </div>
  );
};
